import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { safeInternalPath } from '../../utils/redirect';
import PageLoader from '../ui/PageLoader';

interface AuthenticatedRedirectProps {
  children: React.ReactNode;
}

const AuthenticatedRedirect: React.FC<AuthenticatedRedirectProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Get the returnUrl from query params if it exists
  const searchParams = new URLSearchParams(location.search);
  const returnUrl = safeInternalPath(searchParams.get('returnUrl'));

  if (isLoading) {
    return (
      <PageLoader
        title="Memeriksa autentikasi..."
        subtitle="Mohon tunggu sebentar"
        fullscreen
      />
    );
  }

  if (isAuthenticated) {
    // Redirect authenticated users to home or returnUrl
    return <Navigate to={returnUrl} replace />;
  }

  return <>{children}</>;
};

export default AuthenticatedRedirect;